import { Component } from 'react';
import Header from '../../../Header';
import MessageLink from '../../../MessageLink';
import Footer from '../../../Footer';
import Lgpd from '../../../Lgpd';
import TabelaDinamica from '../../../Tables/TabelaDinamica';
import ErrorBoundary from '../../../ErrorHandler/ErrorBoundary';
import TableSanfonaRentabilidate from '../../../Tables/SanfonaRentabilidade';
import InfoComponent from '../../InfoComponent';

class RentabilidadeTaesaPage extends Component {
	render() {
		return (
			<div>
				{/* HEADER */}{/* LOGIN */}
			<ErrorBoundary>	<Header /></ErrorBoundary>
				<main>

					<InfoComponent image={"plano-taesaprev-rentabilidades"} page={'plano-taesaprev-rentabilidades'}></InfoComponent>

					<div className="_the-content page-planos py-10">
						<div className='container'>
							<div className="row justify-content-center">
								<div className="col-md-10">	
									<h4> Rentabilidade por perfil de investimento  </h4>
									<br />
									<ErrorBoundary><TabelaDinamica page={'PTRentabilidadePerfil'} /></ErrorBoundary>
									<h4> Alocação por segmento de investimento </h4> <br /><br />

									<ErrorBoundary><TabelaDinamica page={'PTRentabilidadeSegmento'} /></ErrorBoundary>
									{/* <ErrorBoundary><RentabilidadeDownloadPdf url={"/plano-b-rentabilidadesDowload"} /></ErrorBoundary> */}

									<br /> <br />

									<h3> Participantes Assistidos - Perfil - Mensal </h3>
									<br />

									{/* <p className="d-lg-none mb-0">
										Nota: Essa informação esta disponível apenas na versão web do site, dado a sua necessidade de detalhamento.
									</p> */}
									<br />

									<ErrorBoundary><TableSanfonaRentabilidate page={"PTRentabilidadeMensal"} /></ErrorBoundary>


								</div>
							</div>
						</div>
						 
					</div>

					{/* Content page */}

				</main>
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default RentabilidadeTaesaPage;